import { closeIcon } from '../../../styles';
import type { AutoExecuteApprovedCounterpartiesModal } from './auto-execute-approved-counterparties-modal';
import { html, repeat, when } from '@microsoft/fast-element';
import { ICompanyApproval } from '../../../types';
import { eventDetail } from '../../../utils/formatting';

export const AutoExecuteApprovedCounterpartiesModalTemplate = html<AutoExecuteApprovedCounterpartiesModal>`
  <fast-dialog class="default-dialog">
    <div class="dialog-header">
      <div class="title">Auto-Execute Approved Counterparties</div>
      <zero-button appearance="stealth" @click="${(x) => x.close()}" class="closing-icon">
        ${closeIcon}
      </zero-button>
    </div>
    <div class="dialog-content">
      <div class="description">
        The Auto-Execute method of execution fills bids and offers based on the list of acceptable
        counterparties and corresponding governing agreements between the parties. The applicable
        governing agreement for the transaction must be specified prior to entering auto-execute
        bids and offers on the Platform.
      </div>
      <div class="company-grid">
        <div class="company-grid-header">
          <div class="company-grid-header-item">Name</div>
          <div class="company-grid-header-item">Governing Agreement</div>
          <div class="company-grid-header-item date-field">Effective Date</div>
        </div>
        <div class="company-approvals-grid">
          ${when(
            (x) => x.isCompanyApprovalsLoaded,
            html<AutoExecuteApprovedCounterpartiesModal>`
              ${repeat(
                (x) => x.companyApprovals,
                html<ICompanyApproval>`
                  <company-approval
                    :approval=${(x) => x}
                    @approvalAdded="${(x, c) => c.parent.approvalAdded(eventDetail(c))}"
                  ></company-approval>
                `
              )}
            `
          )}
        </div>
      </div>
    </div>
    <div class="dialog-footer">
      <zero-button
        @click="${(x) => x.savePreferences()}"
        ?disabled=${(x) => x.isFormValidChanged}
        appearance="primary"
        class="confirm-button"
      >
        ${(x) => (x.isUpdate ? 'Update Preferences' : 'Save Preferences')}
      </zero-button>
    </div>
  </fast-dialog>
`;
